import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";

export class PreviousPregnantComplication extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      Complications: "",
      PregnancyDate: "",
      EvolutionAndTreatment: "",
      myParentTrigger: "",
      patientName: localStorage.getItem("currentVisitName"),
      tablevaluesglobal: {},
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".yesAnswer").click(function () {
      $(".hiddenPart").show();
    });
    $(".noAnswer").click(function () {
      $(".hiddenPart").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      console.log(this.state.tablevaluesglobal[i]["Complications"]);
      var dict = {
        Complications: this.state.tablevaluesglobal[i]["Complications"],
        PregnancyDate: this.state.tablevaluesglobal[i]["PregnancyDate"],
        EvolutionAndTreatment:
          this.state.tablevaluesglobal[i]["EvolutionAndTreatment"],

        PreviousDone: this.state.PreviousDone,
      };
      this.setState({
        loading: true
      })

      axios
        .post(
          this.api_url+""+localStorage.getItem('currentModule')+"/complicationstable/main",
          dict,
          {
            headers: headers,
          }
        )
        .then((response) => {
          this.setState({
            loading: false
          })

          if (response.status == 200) {
            $(".alert-success").show();
            $("#SubmitError").hide();
          } else {
            $(".alert-success").hide();
            $("#SubmitError").show();
            setTimeout(function () {
              // alert('sdsd')
            }, 1500);
            // $(response).each(function (index) {
            // i   var individualResult = '<div className="card"> <div className="card-body">' + index.name + '</div> </div>'
            //     $('.resultDisplay').append(individualResult);
            // });
            // $('.resultDisplay').show();

            axios
              .get(
                this.api_url+"/triage/complicationstable/main",
                {
                  headers: headers,
                }
              )
              .then((response) => {
                console.log(response);
                let table = response.data;
                console.log(table);
                let object = {};
                for (let i = 0; i < table.length; i++) {
                  delete table[i]._id;
                  delete table[i].timeOfRegistration;
                  table[i].clickEvent = () => this.handleRowClick(table[i]);
                }
                // table = JSON.stringify(table);
                this.TableData = table;
                console.log(this.TableData);
                $(".printDetails").fadeIn();
                this.setState({
                  DataLoaded: true,
                });
              })
              .catch((error) => {
                console.log(error);
              });
            this.setState({ response: response.status });

            // console.log(response)resultDisplay
          }
        })
        .catch((error) => {
          $(".alert-success").hide();
          $("#SubmitError").show();
          console.log(error);
        });
    }
    setTimeout(function () {
      window.location.href = "/utilization/of/drugs";
    }, 3500);
  };

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  proceedEvent(event) {
    window.location.href = "/utilization/of/drugs";
  }

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }
  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      trimobj.Complications = data[i][0];
      trimobj.PregnancyDate = data[i][1];
      trimobj.EvolutionAndTreatment = data[i][2];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      ["Prolonged /obstructed labour", "", ""],
      ["Hypertension/ Preeclampsia/eclampsia", "", ""],
      ["Antepartum Hemorrhage", "", ""],
      ["Postpartum Hemorrhage", "", ""],
      ["Feto-maternal infection", "", ""],
      ["Diabetes", "", ""],

      // ["4th", "", ""],
    ];
    const columns = [
      "Complications",
      "Pregnancy/date ",
      "Evolution and treatment ",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const { Complications, PregnancyDate, EvolutionAndTreatment, patientName, loading } =
      this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "Complications",
          field: "Complications",
          sort: "asc",
          width: 50,
        },
        {
          label: "Pregnancy/date ",
          field: "PregnancyDate",
          sort: "asc",
          width: 50,
        },
        {
          label: "Evolution and treatment ",
          field: "EvolutionAndTreatment",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };
    return (
      <div>
        <Headers></Headers>
        <TriageSidebar></TriageSidebar>

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Previous Pregnancy Complication
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Previous Pregancy History Saved
                Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <a
                  className="btn btn-success printDetails"
                  style={displayHidden}
                  onClick={this.PrintWindow}
                >
                  Download Pdf
                </a>
                <br />

                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                   {loading ? 'Loading' : 'Submit'} 
                  </button>
                </div>
              </div>
            </form>

            <div className="modal  HistoryModal" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {" "}
                      {patientName}`s OB Sound Modal
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}
                    <a
                      className="btn btn-success printDetails"
                      style={width100}
                      onClick={() =>
                        print(patientName + "'S OB Sound", "jsx-template")
                      }
                    >
                      Download PDF
                    </a>
                    <br />
                    <a
                      className="btn btn-danger proceed"
                      onClick={this.proceedEvent}
                      style={width100}
                    >
                      Proceed to Next
                    </a>
                    <Preview id={"jsx-template"}>
                      <b>NAME: </b>
                      {patientName}

                      <MDBDataTable striped bordered data={tabledata} />
                    </Preview>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default PreviousPregnantComplication;
